export default __webpack_public_path__ + "static/media/color-generator.39d611d6.png";